/* ==========================================================================
   TF – Treadwell Blog Product Card – added 9/22/26 (Kirkland Consulting)

   - Add to Cart puts the item in the normal Shopify cart (one-time purchase),
     then opens the theme's own cart drawer by using the header cart button,
     so the drawer, count, free-shipping bar and checkout checkbox all work
     exactly as they do everywhere else on the site.
   - Sold-out items: the button stays clickable and opens the product page
     (where the Klaviyo back-in-stock form will be) instead of being greyed out.
   - Changing the option dropdown updates the price and button.
   Uses event delegation, so it keeps working if the theme redraws the article.
   ========================================================================== */
(function () {
  if (window.tfBlogProductCardInit) return;
  window.tfBlogProductCardInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LABEL_ADD = 'Add to Cart';
  var LABEL_ADDING = 'Adding…';
  var LABEL_ADDED = 'Added!';
  // Sold-out button text. When the Klaviyo back-in-stock form is live on the
  // product page, this can change to something like 'Notify Me When Available'
  // (also change it in snippets/tf-blog-product-card.liquid).
  var LABEL_SOLD_OUT = 'Sold Out – View Product';

  function setLabel(button, text) {
    var label = button.querySelector('[data-tf-bpc-add-label]');
    (label || button).textContent = text;
  }

  function showMessage(card, text, isError) {
    var el = card.querySelector('[data-tf-bpc-message]');
    if (!el) return;
    el.textContent = text;
    el.classList.toggle('is-error', !!isError);
    clearTimeout(el._tfTimer);
    el._tfTimer = setTimeout(function () {
      el.textContent = '';
      el.classList.remove('is-error');
    }, 6000);
  }

  // Opens the theme's cart drawer the same way the header cart icon does.
  function openCartDrawer() {
    var toggles = document.querySelectorAll('[data-cart-mini-toggle]');
    var target = null;
    for (var i = 0; i < toggles.length; i++) {
      if (toggles[i].offsetParent !== null) {
        target = toggles[i];
        break;
      }
    }
    if (!target && toggles.length) target = toggles[0];
    if (!target) return false;
    target.click();
    return true;
  }

  // Option dropdown: update price, button and variant id
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-tf-bpc-variant]');
    if (!select) return;

    var card = select.closest('[data-tf-bpc]');
    var option = select.options[select.selectedIndex];
    if (!card || !option) return;

    var priceEl = card.querySelector('[data-tf-bpc-price]');
    if (priceEl) {
      priceEl.textContent = '';
      if (option.dataset.compare) {
        var compare = document.createElement('s');
        compare.className = 'tf-bpc__compare';
        compare.textContent = option.dataset.compare;
        var sale = document.createElement('span');
        sale.className = 'tf-bpc__sale';
        sale.textContent = option.dataset.price;
        priceEl.appendChild(compare);
        priceEl.appendChild(sale);
      } else {
        var price = document.createElement('span');
        price.textContent = option.dataset.price;
        priceEl.appendChild(price);
      }
    }

    var button = card.querySelector('[data-tf-bpc-add]');
    if (button) {
      var available = option.dataset.available === 'true';
      button.dataset.variantId = option.value;
      button.dataset.soldOut = available ? 'false' : 'true';
      button.classList.toggle('is-sold-out', !available);
      setLabel(button, available ? LABEL_ADD : LABEL_SOLD_OUT);
    }
  });

  // Add to Cart
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-tf-bpc-add]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled || button.classList.contains('is-loading')) return;

    var card = button.closest('[data-tf-bpc]');
    var variantId = parseInt(button.dataset.variantId, 10);
    if (!card || !variantId) return;

    // Sold out: go to the product page, with the sold-out option selected.
    if (button.dataset.soldOut === 'true') {
      window.location.href = (card.dataset.productUrl || '/') + '?variant=' + variantId;
      return;
    }

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    setLabel(button, LABEL_ADDING);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Sorry, this item could not be added to your cart.');
          }
          return data;
        });
      })
      .then(function () {
        if (card.dataset.cartRedirect === 'true') {
          window.location.href = card.dataset.cartUrl || ROOT + 'cart';
          return;
        }

        setLabel(button, LABEL_ADDED);

        if (!openCartDrawer()) {
          showMessage(card, 'Added to your cart.', false);
        }

        setTimeout(function () {
          setLabel(button, LABEL_ADD);
        }, 2000);
      })
      .catch(function (error) {
        setLabel(button, LABEL_ADD);
        showMessage(card, error.message || 'Sorry, this item could not be added to your cart.', true);
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  });
})();
